<template>
  <svg
    id="Link_invalid"
    data-name="Link invalid"
    xmlns="http://www.w3.org/2000/svg"
    width="110"
    height="110"
    viewBox="0 0 110 110"
  >
    <path
      id="Path_8681"
      data-name="Path 8681"
      d="M0,0H110V110H0Z"
      fill="none"
    />
    <path
      id="Path_8682"
      data-name="Path 8682"
      d="M65.857,45.611,75.881,35.588a18.908,18.908,0,0,0,0-26.739h0a18.908,18.908,0,0,0-26.739,0L39.118,18.872M25.272,59.458l8.594-8.594M51.053,33.676l8.594-8.594M74.685,74.5,10.234,10.045m8.828,28.884L9.038,48.953a18.908,18.908,0,0,0,0,26.739h0a18.908,18.908,0,0,0,26.739,0L45.8,65.668"
      transform="translate(12.541 11.864)"
      fill="none"
      :stroke="clr"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="3.5"
    />
  </svg>
</template>
<script>
export default {
  props: ["clr"]
};
</script>
